import { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';

function padStart(value: string | number) {
    return String(value).padStart(2, '0');
}

interface Props {
    resetDuration?: number;
}

export default function useTimer({
    resetDuration, // 分钟
}: Props = {}): {
    time: string;

    resetTimer: () => void;
    pause: () => void;
    recordAndReset: () => void;
    regain: () => void;
} {
    const node = useRef<moment.Moment>(moment());
    const record = useRef<moment.Moment>();
    const [time, setTime] = useState<string>('00:00:00');
    const [task, setTask] = useState<ReturnType<typeof setInterval> | null>(
        null,
    );

    const resetTimer = () => {
        setTime('00:00:00');
        node.current = moment();
        if (!task) {
            start();
        }
    };

    const handleTime = useCallback(() => {
        const now = moment();

        const duration = moment.duration(now.diff(node.current));

        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        if (hours >= (resetDuration || 24)) {
            resetTimer();
            return;
        }
        setTime(`${padStart(hours)}:${padStart(minutes)}:${padStart(seconds)}`);
    }, [node]);

    const start = () => {
        setTask(
            setInterval(() => {
                handleTime();
            }, 1000),
        );
    };

    const pause = () => {
        if (task) {
            clearInterval(task);
            setTask(null);
        }
    };

    /**
     * 记录当前时间，并重新计时
     */
    const recordAndReset = () => {
        record.current = node.current;
        resetTimer();
    };
    /**
     * 恢复之前的记录时间 并添加上这其中的时间
     */
    const regain = () => {
        if (!record.current) {
            console.warn('没有可恢复的时间');
            return;
        }
        node.current = record.current;
        handleTime();
    };

    useEffect(() => {
        start();
        return () => {
            pause();
        };
    }, []);

    return { time, resetTimer, pause, recordAndReset, regain };
}
